import angular from 'angular'
import './channel/channel.controller'
import './drop/drop.controller'
import './sets/sets.controller'
import './posts/posts.controller'
import './collectibles/collectibles.controller'
import './bundles/bundles.controller'
import './profile/profile.controller'
import './products/products.controller'
import './home/home.controller'
import './intro/intro.controller'
import './reviews/reviews.controller'
import './logo/logo.controller'
import './channel/related/related.controller'
import './set_checklist/set_checklist.controller'
import './top_prizes/top_prizes.controller'
import './games/games.controller'

angular.module('collectibleApp.pub', [
  'pub.channel',
  'pub.drop',
  'pub.sets',
  'pub.post',
  'pub.collectibles',
  'pub.bundle',
  'pub.profile',
  'pub.products',
  'pub.home',
  'pub.intro',
  'pub.reviews',
  'pub.logo',
  'pub.product_lines',
  'pub.set_checklist',
  'pub.top_prizes',
  'pub.games',
])
